export default __webpack_public_path__ + "images/0xd29687c813d741e2f938f4ac377128810e217b1b.png";